/* Raw Water Co. — enforce min + step on quantity inputs.
   Snaps typed/changed values up to the nearest valid multiple (e.g. min 5, step 5
   -> 5,10,15...). Targets inputs flagged with data-rwc-qty-step. Also coerces the
   cart page quantity inputs for the box product if they carry the data attrs. */
(function () {
  function snap(input) {
    const step = parseInt(input.dataset.rwcQtyStep || input.step || "1", 10) || 1;
    const min = parseInt(input.dataset.rwcQtyMin || input.min || step, 10) || step;
    let v = parseInt(input.value, 10);
    if (isNaN(v) || v < min) v = min;
    // round UP to the nearest valid step above min
    const stepsAbove = Math.ceil((v - min) / step);
    v = min + stepsAbove * step;
    if (String(v) !== input.value) input.value = String(v);
  }

  function nudge(input, dir) {
    const step = parseInt(input.dataset.rwcQtyStep || input.step || "1", 10) || 1;
    const min = parseInt(input.dataset.rwcQtyMin || input.min || step, 10) || step;
    let v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    v = v + dir * step;
    if (v < min) v = min;
    input.value = String(v);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function bind(input) {
    if (input.dataset.rwcQtyBound) return;
    input.dataset.rwcQtyBound = "1";
    input.addEventListener("change", function () { snap(input); });
    input.addEventListener("blur", function () { snap(input); });

    // Wire +/- buttons that sit next to this input (within the same control wrapper).
    const wrap = input.closest(".rwc-pdp__qty-control") || input.parentElement;
    if (wrap) {
      const minus = wrap.querySelector("[data-rwc-qty-minus]");
      const plus = wrap.querySelector("[data-rwc-qty-plus]");
      if (minus) minus.addEventListener("click", function () { nudge(input, -1); });
      if (plus) plus.addEventListener("click", function () { nudge(input, 1); });
    }
  }

  function initAll() {
    document.querySelectorAll("input[data-rwc-qty-step]").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();
